/**
 * Catálogo de cópia em português brasileiro para o recurso `community` (fóruns, tópicos, Hall das
 * Legendas). As chaves espelham as chamadas `t('community.*')` em
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityPtBR = {
  // CommunityPage
  'community.page.seoTitle': 'Comunidade',
  'community.page.seoDescription':
    'Junte-se à comunidade Grymwyrd: fóruns, teorias de lore, ferramentas para Mestre, homebrew e o Hall das Legendas.',
  'community.page.eyebrow': 'A Escuridão que Se Reúne',
  'community.page.title': 'Comunidade',
  'community.page.intro':
    'Troque táticas, especule teorias, compartilhe homebrew e suba em direção ao cânone. Cada mensagem que você posta ganha moedas e reputação no crepúsculo eterno.',
  'community.page.loading': 'Reunindo os fiéis…',
  'community.page.forumCategories': 'Categorias do Fórum',
  'community.page.categoryStats': '{threads} tópicos · {posts} mensagens',
  'community.page.recentActivity': 'Atividade Recente',
  'community.page.liveFeed': 'feed ao vivo',
  'community.page.recentEmpty':
    'Os fóruns estão em silêncio esta noite. Comece uma discussão para despertar os mortos.',
  'community.page.hallOfLegends': 'Hall das Legendas',
  'community.page.hallBlurb': 'Os maiores contribuidores e os personagens que forjaram no cânone.',
  'community.page.enterTheHall': 'Entrar no Hall',
  'community.page.playerSpotlights': 'Destaque de Jogadores',
  'community.page.summoningLegends': 'Invocando lendas…',
  'community.page.sampleNotice': 'Exibindo conteúdo comunitário de amostra enquanto os fóruns ao vivo despertam.',

  // FlagButton
  'community.flag.errorQueued':
    'Não conseguimos alcançar os moderadores agora, mas seu relatório foi enfileirado.',
  'community.flag.ariaLabel': 'Sinalizar esta mensagem para moderação',
  'community.flag.label': 'Sinalizar',
  'community.flag.modalTitle': 'Reportar aos Guardiões',
  'community.flag.successDelivered':
    'Seu relatório foi entregue aos moderadores. Os Guardiões agradecem.',
  'community.flag.close': 'Fechar',
  'community.flag.signInNotice':
    'Você ainda pode descrever o problema, mas deve estar conectado para que o relatório chegue aos moderadores.',
  'community.flag.whyFlagging': 'Por que você está sinalizando isto?',
  'community.flag.reason.spamOrAdvertising': 'Spam ou publicidade',
  'community.flag.reason.harassmentOrAbuse': 'Assédio ou abuso',
  'community.flag.reason.spoilersWithoutWarning': 'Spoilers sem aviso',
  'community.flag.reason.offTopic': 'Fora do tópico',
  'community.flag.reason.otherDescribeBelow': 'Outro (descreva abaixo)',
  'community.flag.describeIssue': 'Descrever o problema',
  'community.flag.detailPlaceholder': 'Conte aos Guardiões o que está errado…',
  'community.flag.cancel': 'Cancelar',
  'community.flag.reporting': 'Reportando…',
  'community.flag.submitReport': 'Enviar relatório',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Fóruns',
  'community.category.seoDescription': 'Discussões no fórum {name} em Grymwyrd.',
  'community.category.breadcrumb': 'Comunidade',
  'community.category.entityTiedPrefix': 'Quadro vinculado à entidade · tópicos podem estar ligados a',
  'community.category.encyclopediaEntries': 'entradas de enciclopédia',
  'community.category.sampleNotice': 'Exibindo tópicos de amostra enquanto o fórum ao vivo desperta.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Hall das Legendas',
  'community.legends.seoDescription':
    'Os maiores contribuidores para Grymwyrd e os personagens que forjaram no cânone.',
  'community.legends.breadcrumb': 'Comunidade',
  'community.legends.title': 'Hall das Legendas',
  'community.legends.intro':
    'Aqui estão os arquitetos do crepúsculo eterno — os contribuidores cujas palavras se tornaram lei, e os personagens tão amados que foram gravados no cânone.',
  'community.legends.loading': 'Acendendo as velas…',
  'community.legends.topContributors': 'Principais Contribuidores',
  'community.legends.noContributors':
    'Nenhuma lenda se levantou ainda. Poste, especule e crie para reclamar seu lugar.',
  'community.legends.canonizedCharacters': 'Personagens Canônicos',
  'community.legends.noCharacters':
    'Nenhum personagem foi canonizado ainda. O bestiário aguarda seu próximo horror.',
  'community.legends.sampleNotice': 'Exibindo legendas de amostra enquanto o hall ao vivo é consagrado.',

  // NestedReplies
  'community.replies.replyBy': 'Resposta de {author}',
  'community.replies.reply': 'Responder',
  'community.replies.replyToPlaceholder': 'Responder a {author}…',
  'community.replies.unlike': 'Desgostar desta mensagem',
  'community.replies.like': 'Gostar desta mensagem',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} reputação',
  'community.spotlight.viewInEncyclopedia': 'Ver {name} na enciclopédia',

  // PostComposer
  'community.composer.placeholder': 'Adicione sua voz ao escuro…',
  'community.composer.signInPrompt': 'Conecte-se para participar da discussão e ganhe moedas por suas palavras.',
  'community.composer.signInToReply': 'Conectar para responder',
  'community.composer.youFallback': 'Você',
  'community.composer.saveError':
    'Sua resposta não pôde ser salva no servidor ainda — ela é exibida apenas localmente.',
  'community.composer.writeReply': 'Escrever uma resposta',
  'community.composer.writePost': 'Escrever uma mensagem',
  'community.composer.replyText': 'Texto da resposta',
  'community.composer.postText': 'Texto da mensagem',
  'community.composer.posting': 'Postando…',
  'community.composer.postReply': 'Postar resposta',
  'community.composer.post': 'Postar',
  'community.composer.cancel': 'Cancelar',
  'community.composer.coinsPerPost': '+{count} moedas por mensagem',
  'community.composer.coinsEarned': '+{count} moedas ganhas por sua mensagem!',

  // ThreadItem
  'community.thread.pinned': 'Tópico fixado',
  'community.thread.byPrefix': 'por',
  'community.thread.repliesTitle': '{count} respostas',
  'community.thread.likesTitle': '{count} gostos',
  'community.thread.viewsTitle': '{count} visualizações',
  'community.thread.entityEntry': 'entrada {type}',

  // ThreadList
  'community.threadList.empty':
    'Nenhuma discussão foi agitada aqui ainda. Seja o primeiro a quebrar o silêncio.',

  // ThreadPage
  'community.threadPage.loading': 'Abrindo o tópico…',
  'community.threadPage.seoDescription': 'Uma discussão nos fóruns da comunidade Grymwyrd.',
  'community.threadPage.replyCount': '{count} respostas',
  'community.threadPage.opened': 'aberto {time}',
  'community.threadPage.entityEntry': 'entrada {type}',
  'community.threadPage.sampleNotice': 'Exibindo discussão de amostra enquanto o fórum ao vivo desperta.',
  'community.threadPage.openingPostBy': 'Mensagem inicial de {author}',
  'community.threadPage.repliesHeading': 'Respostas',
  'community.threadPage.noReplies': 'Sem respostas ainda. Seja o primeiro a responder ao chamado.',
  'community.threadPage.addYourReply': 'Adicione sua resposta',
} as const
